module.exports = __webpack_public_path__ + "static/img/computer-overrides.e33b50c0.svg";